<form autocomplete="off" [formGroup]="innerForm">
    <div class="float-left smart-tag-form-container container" *ngIf="smartTagModel !== null ">
        <ng-template [ngIf]="schemaShouldShowComplexForm">
            <div class="row">
                <div class="col-md-6">
                    <label for="brand">Brand</label>
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" id="brand" formControlName="brand">
                    </div>
                </div>
                <div class="col-md-6">
                    <label for="serialNumber">Serial No.</label>
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" id="serialNumber" formControlName="serialNumber">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <label for="modelNumber">Model</label>
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" id="modelNumber" formControlName="modelNumber">
                    </div>
                </div>
                <div class="col-md-6">
                    <label for="age">Age</label>
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" id="age" formControlName="age">
                    </div>
                </div>
            </div>
        </ng-template>
        <div class="row">
            <div class="col-md-10">
                <label>Description:</label>
                <textarea name="description"
                          formControlName="description"
                          (keyup)="smartTagModel.description = $event.currentTarget['value'];"
                          id="report-image-description" name="report-image-description" rows="3"
                          cols="50" [maxLength]="150"></textarea>
            </div>
        </div>
    </div>
</form>
